const sharingEvents = new Set([
  'share_request_created',
  'share_request_updated',
  'association_removed',
  'repository_retention_confirmed'
]);

export const shareNotificationTarget = (event, isAdmin, userGuid) => {
  const path = isAdmin ? '/admin/connection-requests' : '/account/associations';
  const sender = event.FromUserMasterGuid;
  const action = String(event.Action || '').toLowerCase();
  const sent =
    sender && userGuid
      ? sender.toLowerCase() === userGuid.toLowerCase()
      : ['approved', 'rejected'].includes(action) ||
        /\b(approved|accepted|rejected|declined)\b/i.test(event.Message || '');
  const params = new URLSearchParams({ tab: sent ? 'sent' : 'received' });
  const entity = event.ShareRequestGuid || event.EntityGUID;
  if (entity) params.set('notificationEntity', entity);
  return `${path}?${params}`;
};

export const notificationTarget = value => {
  if (
    typeof value !== 'string' ||
    !value.startsWith('/') ||
    value.startsWith('//') ||
    value.includes('\\')
  )
    return '/account/notifications';
  const target = new URL(value, window.location.origin);
  if (target.origin !== window.location.origin) return '/account/notifications';
  return (
    target.pathname + target.search + (target.hash === '#!' ? '' : target.hash)
  );
};

// Normalize legacy inbox links as well as new realtime events.
export const inboxNotificationTarget = (item, isAdmin, userGuid) => {
  if (sharingEvents.has(item.EventType) || item.Category === 'ShareRequest') {
    const existing = new URL(
      notificationTarget(item.ActionUrl),
      window.location.origin
    );
    if (['sent', 'received'].includes(existing.searchParams.get('tab'))) {
      existing.pathname = isAdmin
        ? '/admin/connection-requests'
        : '/account/associations';
      return existing.pathname + existing.search;
    }
    return shareNotificationTarget(item, isAdmin, userGuid);
  }
  if (!isAdmin && String(item.EventType || '').startsWith('Sponsorship'))
    return '/billing/subscriptions';
  return notificationTarget(item.ActionUrl);
};
